import React, { useRef } from 'react';
import { VideoItemProps } from './type';

export const VideoComponent = ({ url, loop, muted, width, height }: VideoItemProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    return (
        <video
            ref={videoRef}
            src={url}
            autoPlay
            loop={loop}
            muted={muted}
            playsInline
            style={{ width, height, objectFit: 'cover' }}
            className="escalator-video-item"
        />
    );
};
